/**
 * Role gate presentation for a per-tenant write (H §4.4, TMMRSL-0029): STAFF is read-only
 * everywhere. Primary action buttons are hidden when `!canWrite`; inline controls (toggles,
 * inputs) stay visible but disabled, wrapped in `ViewOnlyTooltip`. Presentation only — the
 * server still answers `403 RESELLER_ROLE_FORBIDDEN`, handled by `useApiErrorHandler`.
 */
import type { ReactElement } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Wraps a disabled control so its "View only" tooltip still shows. */
export function ViewOnlyTooltip({ children }: { children: ReactElement }) {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('roles.viewOnly')}>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        {children}
      </Box>
    </Tooltip>
  );
}

/** The one-line "View only" note shown where a hidden action bar would be. */
export function ViewOnlyNote() {
  const { t } = useTranslation();
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {t('roles.viewOnly')}
    </Typography>
  );
}
